import React from "react";
import OurServicesContent from "../contents/OurServicesContent";
import { Helmet } from "react-helmet-async";

const ServicePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Ceylon Hospital in Gampaha is the leading Ayurvedic hospital, renowned for its expert doctors and proven success in holistic healing, specialized treatments, and authentic Ayurvedic therapies, we combine ancient wisdom with advanced technology. Trusted by Sri Lanka for exceptional care, our experienced specialists deliver personalized wellness solutions for lasting health."
        />
        <meta
          name="description"
          content="Authentic Ayurvedic treatments at Ceylon Hospital including Panchakarma, Shirodhara, and herbal medicine. Certified physicians providing personalized wellness programs."
        />
      </Helmet>
      <OurServicesContent />
    </>
  );
};

export default ServicePage;
